<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <branch-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import BranchShowData from "./BranchShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "BranchShow",
        components: {CrudShow, BranchShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.branch.showing',
            }
        },
    }
</script>

